import { SIZE_33, SIZE_FULL } from '@/lib/gridElements/size';
import { ORIENTATION_HORIZONTAL } from '@/lib/gridElements/orientation';

//kpis
import { totalFollowersConfig } from '@/lib/analytics/kpis/twitter/totalFollowers';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/tiktok/followersEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/tiktok/followersEvolutionPercentage';

//charts
import { followerGrowthConfig } from '@/lib/analytics/charts/tiktok/followerGrowthHistory';
import { followersOnlineConfig } from '@/lib/analytics/charts/tiktok/followersOnline';
import { countriesDistributionConfig } from '@/lib/analytics/charts/tiktok/countriesDistributionConfig';
import { genderDistributionConfig } from '@/lib/analytics/charts/tiktok/genderDistribution';

export const CommunityTiktokBusiness = [
    { ...totalFollowersConfig, size: SIZE_33, orientation: ORIENTATION_HORIZONTAL },
    { ...followersEvolutionConfig, size: SIZE_33, orientation: ORIENTATION_HORIZONTAL },
    { ...followersEvolutionPercentageConfig, size: SIZE_33, orientation: ORIENTATION_HORIZONTAL },
    { ...followerGrowthConfig, size: SIZE_FULL },
    countriesDistributionConfig,
    genderDistributionConfig,
    followersOnlineConfig
];

export const requestTiktokBusinessParams = [
    [
        'followers',
        'followers_evolution',
        'followers_evolution_percentage',
        'followers_growth',
        'followers_online'
    ],
    ['countries_distribution', 'gender_distribution']
];

export const requestTiktokBusinessOtherParameters = {
    countries_distribution: {
        type: countriesDistributionConfig.defaultFilter
    }
};
